import { IXmlNode } from '@/app-modules/server-communications';
import { safeCast } from '@/helper';

class SetStageData {
  public newStage: number;

  constructor(node: IXmlNode) {
    this.newStage = safeCast(node.attributes.newstage, -1);
  }
}

export { SetStageData };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/set-stage/set-stage-data.ts